import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../utils/baseQueryWithAuth';

const mdmsUrl = process.env.REACT_APP_MDMS_URL;
// Define a service using a base URL and expected endpoints
export const prepaidDashboardSlice = createApi({
  reducerPath: 'prepaidDashboardSlice',
  baseQuery: baseQueryWithReauth,
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getDashboardData: builder.query({
      query: (params) => ({
        url: `${mdmsUrl}/prepaid-engine/mdms_api/prepaid_dashbaord/${params}`
      }),
      providesTags: ['getDashboardData']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDashboardDataQuery } = prepaidDashboardSlice;
